import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';
import {ELEMENT} from '../../../../incase-domain/elements/base/ElementTypes';
import {selectedElementIdSelector, selectedSlideSelector} from '../../../../store/selectors/slide.selectors';
import VideoElementModal from './createdElementModals/VideoElementModal';

function SelectedElementModal(): JSX.Element {
    const selectedElementId = useSelector(selectedElementIdSelector);
    const slide = useSelector(selectedSlideSelector);

    const selectedElementIndex = useMemo(
        () => slide.elements.findIndex((element) => element.id === selectedElementId),
        [selectedElementId, slide.elements]
    );

    const newlyAddedElement = useMemo(() => {
        return slide.elements.find((element) => element.id === selectedElementId);
    }, [selectedElementId, slide.elements]);

    if (selectedElementIndex < 0 || !newlyAddedElement) {
        return <></>;
    }

    return <>{newlyAddedElement.type === ELEMENT.VIDEO && <VideoElementModal element={newlyAddedElement} />}</>;
}

export default SelectedElementModal;
